import { render, staticRenderFns } from "./FadedButton.vue?vue&type=template&id=0faccc4e"
import script from "./FadedButton.vue?vue&type=script&lang=js"
export * from "./FadedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports